const LamdaURL =
  "https://oqvv2iyycg7oihjl4kyukeefve0xdywg.lambda-url.ap-south-1.on.aws/";

export async function uploadFileViaPresignedUrl(file, username) {
  // Step 1: Ask YOUR backend for a pre-signed URL
  const response = await fetch(LamdaURL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fileName: file.name,
      fileType: file.type,
      username,
    }),
  });

  if (!response.ok) throw new Error("Failed to get upload URL");

  const { presignedUrl } = await response.json();

  // Step 2: Upload directly to S3 using the pre-signed URL
  // No AWS credentials involved here — the URL IS the auth
  const uploadResponse = await fetch(presignedUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });

  if (!uploadResponse.ok) throw new Error("Upload to S3 failed");
}
